import { render, staticRenderFns } from "./FriendLink.vue?vue&type=template&id=9fa34ed2&scoped=true"
import script from "./FriendLink.vue?vue&type=script&lang=js"
export * from "./FriendLink.vue?vue&type=script&lang=js"
import style0 from "./FriendLink.vue?vue&type=style&index=0&id=9fa34ed2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fa34ed2",
  null
  
)

export default component.exports